















import Vue from "vue";
import Menu from "./components/Menu.vue";
import Notification from "./components/Notification.vue";
import mixModal from "./mixins/modal";

export default Vue.extend({
  data() {
    return {
      overallLoading: true,
    };
  },
  components: { Notification },
  name: "App",
  mixins: [mixModal],
  mounted() {
    setTimeout(() => {
      this.overallLoading = false;
    }, 1700);
  },
  computed: {},
});
